/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * A dated moment that moved the business with this carrier. Drawn as a line on the timeline.
 * @export
 * @interface CarrierSignificantEventSummary
 */
export interface CarrierSignificantEventSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierSignificantEventSummary
   */
  carrierSignificantEventId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof CarrierSignificantEventSummary
   */
  occurredOn: LocalDate;
  /**
   *
   * @type {string}
   * @memberof CarrierSignificantEventSummary
   */
  title: string;
}

/**
 * Check if a given object implements the CarrierSignificantEventSummary interface.
 */
export function instanceOfCarrierSignificantEventSummary(
  value: object,
): value is CarrierSignificantEventSummary {
  if (
    !("carrierSignificantEventId" in value) ||
    value["carrierSignificantEventId"] === undefined
  )
    return false;
  if (!("occurredOn" in value) || value["occurredOn"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function CarrierSignificantEventSummaryFromJSON(
  json: any,
): CarrierSignificantEventSummary {
  return CarrierSignificantEventSummaryFromJSONTyped(json, false);
}

export function CarrierSignificantEventSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierSignificantEventSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierSignificantEventId: json["carrierSignificantEventId"],
    occurredOn: json["occurredOn"],
    title: json["title"],
  };
}

export function CarrierSignificantEventSummaryToJSON(
  json: any,
): CarrierSignificantEventSummary {
  return CarrierSignificantEventSummaryToJSONTyped(json, false);
}

export function CarrierSignificantEventSummaryToJSONTyped(
  value?: CarrierSignificantEventSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierSignificantEventId: value["carrierSignificantEventId"],
    occurredOn: value["occurredOn"],
    title: value["title"],
  };
}
